import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { authenticatedRoute } from './_authenticated';

// Code splitting: Lazy load SettingsPage to reduce initial bundle size
const SettingsPage = lazy(() => import('@/pages/SettingsPage'));

/**
 * Settings route - /settings
 * User account settings and plan management
 * Requires authentication
 */
export const settingsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: 'settings',
  component: SettingsPage,
});

// Backward compatibility
export const Route = settingsRoute;
